export default "__VITE_ASSET__RUstSoLn__"